import type { Subcategory } from '~/entities/categories'
import { highlightText } from '~/shared/lib/highlight-text'
import { RadioButton, Text } from '~/shared/ui'
import { useFilters } from '../../../../model'

export function ClassificationItem({
  subcategory,
  searchValue,
}: {
  subcategory: Subcategory
  searchValue: string
}) {
  const { filters, setFilters } = useFilters()

  return (
    <div
      className="flex w-full items-center gap-2 px-2 py-1"
      key={subcategory.label}
    >
      <RadioButton
        className="w-full"
        label={
          <div className="flex flex-col whitespace-normal">
            <Text appearance="BODY2">
              {highlightText(subcategory.metadata.phase.displayLabel, searchValue)}
            </Text>
            {subcategory.metadata.outcome.label !== 'n/a' ? (
              <Text
                className="text-text-secondary"
                appearance="CAPTION"
              >
                {highlightText(
                  `${subcategory.metadata.outcome.displayLabel}${subcategory.metadata.reason.label !== 'n/a' ? `: ${subcategory.metadata.reason.displayLabel}` : ''}`,
                  searchValue,
                )}
              </Text>
            ) : null}
          </div>
        }
        fullLabelWidth
        gutter
        size="small"
        checked={filters.classification === subcategory.label}
        onChange={() => {
          setFilters({
            classification: subcategory.label,
          })
        }}
      />
    </div>
  )
}
